// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__C+qV6","White":"Loader_White__Md8FJ"};